var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.45143V7.00343C12.9993 8.29729 12.5803 9.55624 11.8056 10.5925C11.0309 11.6288 9.94197 12.3869 8.70121 12.7538C7.46046 13.1206 6.13435 13.0766 4.92068 12.6282C3.70701 12.1798 2.67079 11.3511 1.96658 10.2657C1.26236 9.18025 0.927875 7.89627 1.01301 6.60522C1.09814 5.31417 1.59832 4.08523 2.43897 3.10168C3.27961 2.11813 4.41567 1.43266 5.67771 1.14752C6.93975 0.86238 8.26016 0.992836 9.442 1.51943",
    stroke: "#FFD100",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.20343L7.00001 8.20943L5.20001 6.40943",
    stroke: "#FFD100",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistItem);
export default __webpack_public_path__ + "static/media/checklistItem.16cf3d0232b08c7aacca793c30ce86c3.svg";
export { ForwardRef as ReactComponent };